// 设置 publicPath 为空字符串，避免路径污染
// __webpack_public_path__ = ''

import mapBasic from './map-basic'
import mapTool from './map-tool'
import mapSearch from './map-search'
import { setBaseUrl, setToken } from './config'
import httpClient from './http'
// import { LiveTarget } from './businessLogic/liveTarget'

const components = [mapBasic, mapTool, mapSearch]
const install = function (Vue) {
  if (install.installed) return
  components.map((component) => Vue.component(component.name, component))
}
// 判断是否是直接引入文件（通过script导入），如果是，就不用调用Vue.use()
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}
const API = {
  install
}
export default API
export { setBaseUrl, setToken, httpClient }
